import { apiSlice } from './apiSlice';

export interface Feedback {
  id: string;
  userId: string;
  type: string;
  name: string | null;
  email: string | null;
  contactNo: string | null;
  message: string;
  feedbackStatus: string;
  mailSent: boolean;
  mailSentAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface FeedbackResponse {
  data: Feedback[];
  total: number;
  skip: number;
  take: number;
}

export const feedbackApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeedbacks: builder.query<
      FeedbackResponse,
      { skip: number; take: number; search?: string; feedbackType?: string }
    >({
      query: ({ skip, take, search, feedbackType }) => {
        const params = new URLSearchParams();
        params.append('skip', String(skip));
        params.append('take', String(take));
        if (search) {
          params.append('search', search);
        }
     if (feedbackType && feedbackType !== 'all') {
       params.append('type', feedbackType);
     }
        return {
          url: `/message/admin/feedbacks?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['User'], // Reusing User tag for broad invalidation if needed
    }),
  }),
});

export const { useGetFeedbacksQuery } = feedbackApi;
